// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"717":"c0c9a7e5","4124":"c0c9a7e5","6546":"3fc49de4","8639":"53a53c24"}[chunkId] + ".chunk.css";
};